import { Component, OnInit } from "@angular/core";
import { HrserviceService } from "../../hr-manager/service/hrservice.service";
import { ActivatedRoute } from "@angular/router";
import { Router } from "@angular/router";
import { debounceTime, distinctUntilChanged } from "rxjs/operators";
import { Notification, Subject } from "rxjs";
import { EmponboardingService } from "../../employee-onboarding/services/emponboarding.service";
import { MatDialog } from '@angular/material/dialog';
import { FilterDialogComponent, FilterDialogData } from '../shared/filter-dialog/filter-dialog.component';
import { AddItemDialogComponent } from '../shared/add-item-dialog/add-item-dialog.component';
import { AddDialogConfigs } from '../shared/add-item-dialog/add-dialog-configs';
import { ExcelService } from "src/app/core/services/excel.service";
import { environment } from '../../../../environments/environment';
@Component({
  selector: "app-empolyee-list",
  templateUrl: "./empolyee-list.component.html",
  styleUrls: ["./empolyee-list.component.scss", "../shared/hr-table-styles.scss"],
  providers: [ExcelService]
})
export class EmpolyeeListComponent2 implements OnInit {
  headingEmployee: string = "Employees";
  umail: string = this.EmpOnboardingService.umail;
  employeedata: any;
  totalCount: number = 0;
  totalPages: number = 0;
  currentPage: number = 1;
  email: string;
  pageSize: number = 10;
  employeeEmail: string;
  leavevalue: number;
  searchQuery: string;
  numButtons: number = 5;
  middle: number;
  start: number;
  end: number;
  private searchSubject = new Subject<string>();
  // Business/Department filter data
  businessList: any[] = [];
  departmentList: any[] = [];
  selectedBusiness: any = null;
  selectedDepartment: any = null;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private hrservice: HrserviceService,
    private EmpOnboardingService: EmponboardingService,
    private dialog: MatDialog,
    private excelService: ExcelService
  ) {
    this.searchSubject
      .pipe(debounceTime(1000), distinctUntilChanged())
      .subscribe((query) => {
        console.log(query);
        this.email = query;
        this.currentPage = 1;
        this._EmployeeList(this.currentPage, this.email);
      });
  }

  _onSearchInput(event: Event) {
    console.log(event);
    this.searchSubject.next(this.searchQuery);
    console.log(this.searchQuery);
  }

  // Method to handle search input from the new header component
  onSearchInput(query: string) {
    this.searchQuery = query;
    this.searchSubject.next(query);
  }

  // Open filter dialog with required fields
  openFilterDialog(): void {
    // Fetch business/department data before opening dialog
    this.hrservice.getDepartments().subscribe((res: any) => {
      this.businessList = res.data || [];

      // Prepare filter fields
      const filterData: FilterDialogData = {
        title: 'Filter',
        filters: [
          { key: 'email', label: 'Search employees', type: 'text', placeholder: 'Enter Email / First Name / Employee ID' },
          { key: 'employee_type', label: 'Employee Type', type: 'select', options: [
            { label: 'On-Roll', value: 'on-roll' },
            { label: 'Off-Roll', value: 'off-roll' }
          ], placeholder: 'Select Employee Type' },
          { key: 'status', label: 'Status', type: 'select', options: [
            { label: 'Active', value: 'active' },
            { label: 'Inactive', value: 'inactive' }
          ], placeholder: 'Select Status' },
          { key: 'business_id', label: 'Business', type: 'select', options: this.businessList.map(b => ({ label: b.name, value: b.id, departments: b.departments })), placeholder: 'Select Business' },
          { key: 'department_id', label: 'Department', type: 'select', options: [], placeholder: 'Select Department' }
        ],
        currentFilters: { ...this.currentFilters }
      };

      // Open dialog
      const dialogRef = this.dialog.open(FilterDialogComponent, {
        width: '600px',
        data: filterData
      });

      // Listen for dialog events
      dialogRef.componentInstance.data = filterData;
      dialogRef.componentInstance.businessList = this.businessList;

      dialogRef.afterClosed().subscribe(result => {
        if (result !== undefined) {
          this.applyFilters(result);
        }
      });
    });
  }


  // Store current filters and filter state
  currentFilters: any = {
    email: '',
    employee_type: '',
    status: '',
    department_id: '',
    business_id: ''
  };
  isFilterApplied: boolean = false;

  // Apply filters to employee list
  applyFilters(filters: any): void {
    // Always send all params, empty string if not filled
    this.currentFilters = {
      email: filters.email || '',
      employee_type: filters.employee_type || '',
      status: filters.status || '',
      department_id: filters.department_id || '',
      business_id: filters.business_id || ''
    };
    // Set filter flag if any filter is filled
    this.isFilterApplied = Object.values(this.currentFilters).some(val => val && val !== '');
    this.getFilteredEmployees(1);
  }

  // Call API with all filter params
  getFilteredEmployees(page: number): void {
    const params = {
      page: page,
      email: this.currentFilters.email || '',
      employee_type: this.currentFilters.employee_type || '',
      status: this.currentFilters.status || '',
      department_id: this.currentFilters.department_id || '',
      business_id: this.currentFilters.business_id || ''
    };
    const url = `${environment.url}travelex_app/api/v2/admin/employees`;
    this.hrservice.getWithAuth(url, params).subscribe((res: any) => {
      this.employeedata = res.data;
      this.totalCount = res.meta?.count || 0;
      this.totalPages = Math.ceil(this.totalCount / this.pageSize);
      this.currentPage = page;
    });
  }

  // Export with filters (always use current filter state, always send all params)
  exportEmployees(): void {
    const params = {
      page: this.currentPage,
      email: this.currentFilters.email || '',
      employee_type: this.currentFilters.employee_type || '',
      status: this.currentFilters.status || '',
      department_id: this.currentFilters.department_id || '',
      business_id: this.currentFilters.business_id || ''
    };
    this.hrservice.getEmployeesExport(params).subscribe((blob: any) => {
      const a = document.createElement('a');
      const objectUrl = URL.createObjectURL(blob);
      a.href = objectUrl;
      a.download = 'employees_export.xlsx';
      a.click();
      URL.revokeObjectURL(objectUrl);
    });
  }

  _EmployeeList(page: number, email: string) {
    try {
      this.hrservice.EmployeeList(page, email).subscribe((res: any) => {
        console.log(res.data);
        this.totalCount = res.meta.count;
        this.totalPages = Math.ceil(this.totalCount / this.pageSize);
        this.router.navigate([], {
          relativeTo: this.route,
          queryParams: { page: this.currentPage, email: this.searchQuery },
          queryParamsHandling: "merge",
        });
        this.employeedata = res.data;
        console.log(this.employeedata);
      });
    } catch (error) {
      console.error("An error occurred:", error);
      throw new Error("Something went wrong. Please try again later.");
    }
    console.log("all employee");
  }
  is_Disabled(isdisabled: Number) {
    console.log(isdisabled);
    if (isdisabled == 1) {
      return "Inactive";
    } else {
      return "Active";
    }
  }

  ngOnInit(): void {
    this.route.queryParams.subscribe((params) => {
      const page = +params["page"] || 1;
      const email = params["email"] || '';
      this.currentPage = page;
      this.email = email;
      this.searchQuery = this.email;
    });
    this._EmployeeList(this.currentPage, this.email);
  }
  previousPage() {
    if (this.currentPage > 1) {
      this.currentPage--;
      this.handlePageChange(this.currentPage);
    }
  }

  nextPage() {
    if (this.currentPage < this.totalPages) {
      this.currentPage++;
      this.handlePageChange(this.currentPage);
    }
  }
  firstPage() {
    this.currentPage = 1;
    this.handlePageChange(this.currentPage);
  }
  lastPage() {
    this.currentPage = this.totalPages;
    this.handlePageChange(this.currentPage);
  }
  getNumericButtons(): number[] {
    this.numButtons = 10;
    this.middle = Math.ceil(this.numButtons / 2);
    this.start = Math.max(1, this.currentPage - this.middle + 1);
    this.end = Math.min(this.totalPages, this.start + this.numButtons - 1);

    const buttons: number[] = [];
    for (let i = this.start; i <= this.end; i++) {
      buttons.push(i);
    }

    return buttons;
  }

  gotoPage(page: number) {
    this.currentPage = page;
    this.handlePageChange(this.currentPage);
  }

  // Unified page change handler
  handlePageChange(page: number) {
    if (this.isFilterApplied) {
      this.getFilteredEmployees(page);
    } else {
      this._EmployeeList(page, this.email);
    }
  }

  openUserProfile(user: any,) {
    // window.location.href = '/verify-user-data?umail=' + this.umail + '&email=' + user.email;
    // if(status=="approved"){ 
    // console.log(event);
    // if(event.cellIndex !=4){

    window.open('/onboarding?umail=' + this.umail + '&emp_id=' + user.emp_id + '&email=' + user.email, '_blank')
    // }
    // }
    // else{
    // window.open('/verify-data?umail=' + this.umail + '&email=' + user.email, '_blank')
    // }

  }

  _addPatrnityLeaves(empId: number, leavevalue: number) {
    try {
      this.hrservice.addPatrnity(empId, leavevalue).subscribe((res: any) => {
        alert(res.message);
        this.ngOnInit();
      });
    } catch (error) {
      console.error("An error occurred:", error);
      throw new Error("Something went wrong. Please try again later.");
    }
  }


  addEmployee() {
    // Redirect to external add employee page with user email using environment URL
    const baseUrl = environment.url.endsWith('/') ? environment.url.slice(0, -1) : environment.url;
    const addEmployeeUrl = `${baseUrl}/add-new-employee?umail=${this.umail}`;
    window.open(addEmployeeUrl, '_blank');
  }

  // ...existing code...

  private getExportDate(): string {
    return new Date().toISOString().slice(0, 10);
  }
}
